import { ThemeToggle } from './theme'
import { WayIn } from './WayIn'

/**
 * What the platform's own masthead offers besides the site's identity: the
 * theme, and the way in.
 *
 * It renders the controls and not the box around them. Where they SIT is the
 * shell's own layout.
 *
 * The button is secondary rather than filled. A masthead is chrome — where you
 * go and what you reach for — so it carries no confident mark; the one of those
 * on a screen belongs to the act the screen was opened to perform.
 */
export function SiteAccount({ onSignIn }: { onSignIn?: () => void }) {
  return (
    <>
      <ThemeToggle />
      <WayIn onSignIn={onSignIn} variant="secondary" />
    </>
  )
}
